import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment.prod';
import { shareReplay, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { paymentMethodPostDataInterface } from 'src/_lib/interfaces/request-interfaces/payment-method.interface';

@Injectable({
  providedIn: 'root'
})
export class PaymentMethodService {
  private endpoint: string = environment.apiUrl;
  private cartSettingsCache$: Observable<any> | null = null;

  constructor(private http: HttpClient) { }

  paymentService(): Observable<any> {
    if (!this.cartSettingsCache$) {
      this.cartSettingsCache$ = this.http.get(this.endpoint + 'cart-setting').pipe(
        shareReplay(1),
        catchError(err => {
          this.cartSettingsCache$ = null;
          return throwError(() => err);
        })
      );
    }
    return this.cartSettingsCache$;
  }

  submitCreditCard(data: paymentMethodPostDataInterface): Observable<any> {
    return this.http.post(this.endpoint + 'payment-method', data);
  }
}